import type { SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement>;

/*
 * Layout props go through `style`: the global CSS bundle opens with the `@namespace` of
 * default-css.css, so class selectors never match SVG elements.
 */
const noShrink = { flexShrink: 0 };

export function MapIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 32 32"
      width="20"
      height="20"
      fill="currentColor"
      aria-hidden
      style={noShrink}
      {...props}
    >
      <path d="M22 3c-3.3 0-6 2.7-6 6 0 1 .4 2 .9 3.1.5 1.1 1.1 2.3 1.7 3.4 1.3 2.2 2.6 4 2.6 4l.8 1.2.8-1.2s1.3-1.8 2.6-4c.6-1.1 1.2-2.3 1.7-3.4.5-1.1.9-2.1.9-3.1 0-3.3-2.7-6-6-6zM12 4.9 4 8.3v19.2l8-3.5 8 3 8-3.4v-8.7c-.6 1.2-1.3 2.4-2 3.4v4l-5 2.1v-1.6l-1.5-2.1-.5-.8v4.6l-6-2.2V7.4l1.1.4c.1-.7.3-1.3.5-1.9zM22 5c2.2 0 4 1.8 4 4 0 .4-.2 1.3-.7 2.3-.4 1-1.1 2.2-1.7 3.2-.8 1.4-1.2 1.9-1.6 2.6-.5-.7-.8-1.2-1.6-2.6-.6-1-1.3-2.2-1.7-3.2C18.2 10.3 18 9.4 18 9c0-2.2 1.8-4 4-4zM11 7.5v14.8l-5 2.2V9.7zm11 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" />
    </svg>
  );
}

export function PhoneIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      aria-hidden
      style={noShrink}
      {...props}
    >
      <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z" />
    </svg>
  );
}

export function MailIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      aria-hidden
      style={noShrink}
      {...props}
    >
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="m22 7-10 6L2 7" />
    </svg>
  );
}
